export default class Book {
	constructor(biblia) {
		this.biblia = biblia;
	}

	setBooksData(data) {
		const hidden = document.querySelector('#biblia-online #parresia-biblia-books');
		if (hidden) {
			hidden.value = JSON.stringify(data);
		}
	}

	createBook(list, book) {
		const name = this.createBookName(book.chapter);
		const icon = this.createBookDropdownIcon();
		const chapters = this.createBookChapters(book);
		const context = this.createBookContext(book, name, icon, chapters);

		list.appendChild(context);
		this.openBookContext(context);
		this.backToSideBar();
	}

	createBookName(name) {
		const bookName = document.createElement('span');
		bookName.innerText = name;

		return bookName;
	}

	createBookDropdownIcon() {
		const icon = document.createElement('i');
		icon.classList.add('fa-solid', 'fa-chevron-down');

		return icon;
	}

	createBookContext(book, name, icon, chapters) {
		const bookContext = document.createElement('div');
		bookContext.setAttribute('data-testament', book.meta.testament);
		bookContext.setAttribute('data-book', JSON.stringify(book));

		const div = document.createElement('div');
		div.classList.add('book');
		div.appendChild(name);
		div.appendChild(icon);

		bookContext.appendChild(div);
		bookContext.appendChild(chapters);
		return bookContext;
	}

	createBookChapters(book) {
		const chapters = document.createElement('div');
		chapters.classList.add('chapters');

		for (let index = 1; index <= book.chapter_count; index++) {
			const chapter = document.createElement('span');
			chapter.classList.add('chapter');
			chapter.innerText = index;
			chapter.setAttribute('data-chapter', index);
			chapter.setAttribute('data-book', book.slug);

			chapter.addEventListener('click', () => {
				this.biblia.chapter.setChapter(book, index);
				this.selectChapter(chapter);

				this.changeMobileView();
			});

			chapters.appendChild(chapter);
		}

		return chapters;
	}

	selectChapter(chapter) {
		const selectedBooks = document.querySelectorAll('#biblia-online .list > .selected');
		selectedBooks.forEach(element => element.classList.remove('selected'));

		const selectedChapters = document.querySelectorAll('#biblia-online .list > div > .chapters .chapter.selected');
		selectedChapters.forEach(element => element.classList.remove('selected'));

		const parent = chapter.parentElement.parentElement;

		parent.classList.add('selected');
		chapter.classList.add('selected');
	}

	backToSideBar() {
		const button = document.querySelector('#biblia-online > .base > .content .show-sidebar');

		button.addEventListener('click', () => {
			this.changeMobileView();
		});
	}

	changeMobileView() {
		const content = document.querySelector('#biblia-online > .base > .sidebar');
		const sidebar = document.querySelector('#biblia-online > .base > .content');

		content.classList.toggle('mobile-deactive');
		sidebar.classList.toggle('mobile-deactive');
	}

	openBookContext(context) {
		context.addEventListener('click', (e) => {
			if (context.contains(e.target) && (!e.target.classList.contains('chapter') && !e.target.classList.contains('chapters'))) {
				context.classList.toggle('selected')
			}
		});

		const list = context.parentElement;

		list.addEventListener('click', (e) => {
			if (!context.contains(e.target)) {
				context.classList.remove('selected');
			}
		});
	}

	getImagesUrl() {
		const url = document.querySelector('#parresia-image-url');
		return url?.value || '';
	}
}
